import account from "./accountReducer";
import header from "./headerReducer";
import languageSwitcher from "./languageSwitcherReducer";
import menu from "./menuReducer";
import overlay from "./overlayReducer";
import realityCheck from "./realityCheckReducer";
import search from "./searchReducer";
import ui from "./uiReducer";
import userContext from "./userContextReducer";
import stateSwitcher from "./stateSwitcherReducer";
import native from "./nativeReducer";
import controlCenter from "./controlCenterReducer";
import settings from "./settingsReducer";
import feature from "./featureReducer";
import casino from "./casinoReducer";
import seo from "./seoReducer";

const rootReducer = {
  reducer: {
    account,
    header,
    languageSwitcher,
    stateSwitcher,
    menu,
    overlay,
    realityCheck,
    controlCenter,
    search,
    ui,
    userContext,
    native,
    casino,
    settings,
    feature,
    seo
  }
};

export default rootReducer;
